import gql from 'graphql-tag';

const NAME =
  'compositions_CaseInboundProgramPanel_updateCaseInboundProgramShipTo';

export default gql`
  mutation ${NAME} (
    $caseId: ID!
    $inboundProgramShipTo: String
  ) {
    updateCase(
      input: {
        id: $caseId,
        patch: {
          inboundProgramShipTo: $inboundProgramShipTo
        }
      }
    ) {
      case {
        id
        inboundProgramNumber {
          id
          isUsxpress
          inboundProgramAccountType
          locations {
            ... on Dealer {
              billTo
              displayAddress {
                city
                province
              }
              id
              name
              shipTo
            }
            ... on Customer {
              billTo
              city
              id
              name
              shipTo
              state
            }
          }
        }
        inboundProgramShipTo
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/compositions/CaseInboundProgramPanel/withInboundProgramLocationSelect/updateCaseInboundProgramShipToMutation.js